<template>
  <b-container fluid>
    <div class="side-frame">用户基础信息</div>
    <b-row class="mt-2">
      <b-col>
        <b-card>
          <div style="font-size: 14px; color: #606266">
            <span>Status：{{ formData.userStatusName }}</span>
            <el-divider direction="vertical"></el-divider>
            <span
              >Create：{{ formData.createByName }} at
              {{ formData.createTime }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span
              >Modify：{{ formData.modifyByName }} at
              {{ formData.modifyTime }}</span
            >
          </div>
          <div class="d2-mt">
            <el-form
              ref="formData"
              :model="formData"
              :rules="rules"
              :disabled="disabled"
            >
              <el-row :gutter="20">
                <el-col
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item label="用户名称" prop="userName">
                    <el-input
                      v-model="formData.userName"
                      maxlength="20"
                      placeholder="请输入用户名称"
                      size="medium"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item label="手机号码" prop="userMobileNo">
                    <el-input
                      v-model.number="formData.userMobileNo"
                      maxlength="11"
                      placeholder="请输入手机号码"
                      size="medium"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :offset="8"></el-col>
                <el-col
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item label="邮件地址" prop="userEmail">
                    <el-input
                      v-model="formData.userEmail"
                      maxlength="50"
                      placeholder="请输入邮件地址"
                      size="medium"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item label="微信账号" prop="userWechat">
                    <el-input
                      v-model="formData.userWechat"
                      maxlength="50"
                      placeholder="请输入微信账号"
                      size="medium"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :offset="8"></el-col>
                <el-col
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item label="所属机构" prop="orgCode">
                    <org-cascader
                      :valueString.sync="formData.orgAllCode"
                      :lastValue.sync="formData.orgCode"
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  :sm="{ span: 24 }"
                  :md="{ span: 12 }"
                  :lg="{ span: 12 }"
                >
                  <el-form-item label="担任职务" prop="userJob">
                    <el-input
                      v-model="formData.userJob"
                      maxlength="50"
                      placeholder="请输入担任职务"
                      size="medium"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <div class="side-frame" v-if="disabled">
                  已拥有角色权限
                </div>
                <div class="side-frame" v-if="!disabled">
                  角色权限
                </div>
                <vxe-table
                  ref="roleTable"
                  border
                  show-overflow
                  row-id="bizSysRoleID"
                  :data="allRoleData"
                  :checkbox-config="checkboxConfig"
                  :height="400"
                >
                  <vxe-table-column
                    type="checkbox"
                    width="60"
                  ></vxe-table-column>

                  <vxe-table-column
                    field="bizSysRoleName"
                    title="角色名称"
                  ></vxe-table-column>
                  <template v-slot:empty="{}">
                    <div style="text-align: center">
                      <img src="/image/static/img/nodata.png" />
                      <p class="no-data">
                        用户暂未选择角色
                      </p>
                    </div>
                  </template>
                </vxe-table>
              </el-row>
            </el-form>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
/* eslint-disable no-mixed-spaces-and-tabs */
import validate from '@/libs/util.validate'
import { mapActions } from 'vuex'
export default {
  props: {
    params: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkboxConfig: {
        checkRowKeys: [],
        highlight: true,
        reserve: true,
        checkMethod: () => {
          return !this.disabled
        },
      },
      allRoleData: [],
      ownedRoleList: [],
      formData: {},
      rules: {
        userMobileNo: [
          {
            required: true,
            message: '请输入手机号码',
            trigger: 'blur',
          },
          {
            pattern: /^\d{11}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur',
          },
        ],
        userName: [
          {
            required: true,
            message: '请输入用户名称',
            trigger: 'blur',
          },
        ],
        userEmail: [
          {
            required: false,
            pattern: /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/,
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.loadRoleData()
    this.getData()
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    getData() {
      if (!this.params.userCode) return
      this.$api
        .sysUserDetailApi({ userCode: this.params.userCode })
        .then((res) => {
          this.formData = res.body
        })
    },
    loadRoleData() {
      this.loadOwnedRoleList()
      // if (!this.disabled) this.loadAllRoleData()
    },

    loadOwnedRoleList() {
      if (!this.params.userCode) {
        if (!this.disabled) {
          this.loadAllRoleData()
        }
      } else {
        this.$api
          .sysUserRoleListApi({ userCode: this.params.userCode })
          .then((res) => {
            if (this.disabled) {
              this.allRoleData = res.body.data
            }
            res.body.data.forEach((item) => {
              this.checkboxConfig.checkRowKeys.push(item.bizSysRoleID)
            })
            if (!this.disabled) {
              this.loadAllRoleData()
            }
          })
      }
    },

    loadAllRoleData() {
      this.$api.sysRoleAllApi().then((res) => {
        this.allRoleData = res.body.data
      })
    },
    async save() {
      let arr = this.$refs.roleTable
        .getCheckboxRecords(true)
        .concat(this.$refs.roleTable.getCheckboxReserveRecords())

      const result = await validate.formValidate([this.$refs.formData])
      if (!result) return
      this.formData.roleList = arr
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .sysUserSaveApi(this.formData)
        .then(() => {
          loadingInstance.close()
          this.saveOkQuestion()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    saveOkQuestion() {
      // this.$alert('系统用户数据保存成功', '提示信息', {
      //   confirmButtonText: '确定',
      //   callback: () => {
      //     this.closeCurPage()
      //     //刷新列表
      //     this.$eventBus.$emit('sysUserTableReload')
      //   },
      // })

      this.$message({
        showClose: true,
        message: '系统用户数据保存成功',
        type: 'success',
      })
      this.$eventBus.$emit('sysUserTableReload')
      this.closeCurPage()
    },
    async closeCurPage() {
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.scmInfo-uploader {
  border: 1px dashed #d9d9d9;
  width: 270px !important;
  height: 180px;
  line-height: 180px !important;
  text-align: center;
}
.avatarEvent-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 270px !important;
  height: 180px;
  line-height: 180px !important;
  text-align: center;
}

.avatarEvent {
  width: 270px !important;
  height: 180px;
  display: block;
}

.thumbnail-uploader {
  border: 1px dashed #d9d9d9;
  width: 180px !important;
  height: 120px;
  line-height: 120px !important;
  text-align: center;
}
.thumbnail-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 180px !important;
  height: 120px;
  line-height: 120px !important;
  text-align: center;
}

.thumbnail {
  width: 180px !important;
  height: 120px;
  display: block;
}
.top-scroll {
  height: 100%;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: scroll;
}
</style>
